import { Link } from 'react-router-dom';
import { articleList } from '@/mocks/articles';

export default function ArticlePreviewSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              体育资讯
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新赛事动态与深度分析</p>
          </div>
          <Link to="/articles" className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors">
            查看全部资讯 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articleList.slice(0, 3).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                  <span className="text-xs text-foreground-400">{article.readTime}阅读</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2">{article.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>

        <Link to="/articles" className="sm:hidden flex items-center justify-center gap-1 mt-6 text-sm text-primary-500 font-medium">
          查看全部资讯 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}